import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { jobGroupAutoCompleteInput$, jobGroupAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const JobGroupAutoSuggest = renderAutoSuggestWithOptions(
   jobGroupAutoCompleteObservable$,
   jobGroupAutoCompleteInput$,
);

JobGroupAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: {
      id: null,
      name: '',
   },
   filterCompany: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Job Group...',
};

export default JobGroupAutoSuggest;
